import _ from 'lodash';
import React from 'react';
import loadImage from 'blueimp-load-image';

import removeImage from './assets/remove.svg';
import pdfImage from './assets/pdf.svg';

import './styles.css';

const FILE_TYPE_TO_PREVIEW_ICON = {
  'application/pdf': pdfImage
};

const SMALL = 'small';
const LARGE = 'large';
const DEFAULT = LARGE;

const DROPZONE_PREVIEW_OPTIONS = {
  [DEFAULT]: {
    canvas: true,
    maxWidth: 400,
    maxHeight: 400
  },
  [LARGE]: {
    canvas: true,
    maxWidth: 400,
    maxHeight: 400
  },
  [SMALL]: {
    canvas: true,
    maxWidth: 350,
    maxHeight: 350
  }
};

const DropzonePreview = ({file, removeFile, type}) => {
  /*
  For every type that's not an image we use a preview icon
  If a type is not mapped to an icon we assume it's an image
  */
  const previewIcon = _.get(FILE_TYPE_TO_PREVIEW_ICON, file.type);

  // Set image orientation
  let loadImageOptions = DROPZONE_PREVIEW_OPTIONS[type || DEFAULT];

  const isFileImage = !_.isNil(file.type.match('image/*'));

  if (isFileImage) {
    loadImage.parseMetaData(file, data => {
      if (data.exif && data.exif.get('Orientation')) {
        loadImageOptions = {
          ...loadImageOptions,
          orientation: data.exif.get('Orientation')
        };
      }
      loadImage(
        file,
        canvas => {
          file.preview = canvas.toDataURL(file.type);
        },
        loadImageOptions
      );
    });
  }

  return (
    <div className="DropzonePreviewContainer">
      {previewIcon && <img src={previewIcon} alt={file.name} />}
      {!previewIcon && (
        <img src={file.preview} key={file.lastModified} alt={file.name} />
      )}
      {removeFile && (
        <div className="removeButton" onClick={removeFile}>
          <img src={removeImage} alt={'Remove file'} />
        </div>
      )}
    </div>
  );
};

export default DropzonePreview;
